<template>
  <div id="area-screen-box">
    <div id="area-screen">
      <header class="header">
        <span>全国大脑学习力数据中心</span>
        <div @click="fullScreen" class="header-screen">{{ isFullScreen ? '退出' : '切换' }}全屏</div>
      </header>
      <div id="screen-country">
        <div class="left">
          <div class="title">
            <img src="@/assets/areaScreen/area-icon1.png" alt="" />
            <span>全国</span>基本信息
          </div>
          <div class="student-number">
            <div>
              <div class="student-info">
                <p>今日活跃学生数</p>
                <p>
                  <span>{{ replaceNumber(online.todayTotalOnlineCount) }}</span
                  >人
                </p>
              </div>
            </div>
            <div>
              <div class="student-info">
                <p>在线学生数</p>
                <p>
                  <span>{{ replaceNumber(online.currentOnlineCount) }}</span
                  >人
                </p>
              </div>
            </div>
          </div>
          <ul class="org-info">
            <li>
              <img src="@/assets/areaScreen/area-icon5.png" alt="" />
              <p>学校总数</p>
              <div>
                <span>{{ replaceNumber(basicInfo.organizationCount) }}</span
                >个
              </div>
            </li>
            <li>
              <img src="@/assets/areaScreen/area-icon6.png" alt="" />
              <p>学生总数</p>
              <div>
                <span>{{ replaceNumber(basicInfo.userCount) }}</span
                >人
              </div>
            </li>
            <!--<li>
              <img src="@/assets/areaScreen/area-icon7.png" alt="" />
              <p>注册账号数</p>
              <div>
                <span>{{ replaceNumber(basicInfo.userCount) }}</span
                >个
              </div>
            </li>-->
          </ul>
          <div class="title">
            <img src="@/assets/areaScreen/area-icon2.png" alt="" />
            学习力排名
          </div>
          <ul class="table-rank" ref="tableRank">
            <li class="table-head">
              <div class="table-td">排名</div>
              <div class="table-td">地区</div>
              <div class="table-td">学生数</div>
              <div class="table-td">学校数</div>
            </li>
            <li v-for="(item, index) in regionalRanking.filter((f, i) => i < 3)">
              <div class="table-td">
                <img :src="require(`@/assets/areaScreen/area-ranking${index + 1}.png`)" alt="" />
              </div>
              <div class="table-td">{{ item.address }}</div>
              <div class="table-td">{{ replaceNumber(item.studentCount) }}</div>
              <div class="table-td number">{{ item.schoolCount }}</div>
            </li>
          </ul>
          <ul class="table-rank2" ref="tableRank">
            <li v-for="(item, index) in regionalRanking.filter((f, i) => i >= 3)">
              <div class="table-td">
                <span>{{ index + 4 < 10 ? '0' + (index + 4) : index + 4 }}</span>
              </div>
              <div class="table-td">{{ item.address }}</div>
              <div class="table-td">{{ replaceNumber(item.studentCount) }}</div>
              <div class="table-td number">{{ item.schoolCount }}</div>
            </li>
          </ul>
        </div>
        <div class="right">
          <div class="right-statistice-wrapper">
            <div class="right-statistice-item">
              <img class="statistice-header" src="@/assets/areaScreen/assess-bar.png" />
              <div class="statistice-container">
                <div class="statistice-container-item">
                  <img class="container-item-icon" src="@/assets/areaScreen/statistice-user.png" />
                  <div class="container-item-data">
                    <span class="container-item-data-number">{{ statistics.evaluationData.organizationUserCount | formetNumber }}</span>
                    <span class="container-item-data-label">累计测评学生数</span>
                  </div>
                </div>
                <div class="statistice-container-item">
                  <img class="container-item-icon" src="@/assets/areaScreen/statistice-num.png" />
                  <div class="container-item-data">
                    <span class="container-item-data-number">{{ statistics.evaluationData.totalUsageCount | formetNumber }}</span>
                    <span class="container-item-data-label">累计测评次数</span>
                  </div>
                </div>
                <div class="statistice-container-item">
                  <img class="container-item-icon" src="@/assets/areaScreen/statistice-daynum.png" />
                  <div class="container-item-data">
                    <span class="container-item-data-number">{{ statistics.evaluationData.todayUsageCount | formetNumber }}</span>
                    <span class="container-item-data-label">今日新增测评次数</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="right-statistice-item">
              <img class="statistice-header" src="@/assets/areaScreen/train-bar.png" />
              <div class="statistice-container">
                <div class="statistice-container-item">
                  <img class="container-item-icon" src="@/assets/areaScreen/statistice-user.png" />
                  <div class="container-item-data">
                    <span class="container-item-data-number">{{ statistics.trainingData.organizationUserCount | formetNumber }}</span>
                    <span class="container-item-data-label">累计训练学生数</span>
                  </div>
                </div>
                <div class="statistice-container-item">
                  <img class="container-item-icon" src="@/assets/areaScreen/statistice-num.png" />
                  <div class="container-item-data">
                    <span class="container-item-data-number">{{ statistics.trainingData.totalUsageCount | formetNumber }}</span>
                    <span class="container-item-data-label">累计训练次数</span>
                  </div>
                </div>
                <div class="statistice-container-item">
                  <img class="container-item-icon" src="@/assets/areaScreen/statistice-daynum.png" />
                  <div class="container-item-data">
                    <span class="container-item-data-number">{{ statistics.trainingData.todayUsageCount | formetNumber }}</span>
                    <span class="container-item-data-label">今日新增训练次数</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div ref="mapChars" id="map-chars"></div>
          <div class="map-legend">
            <h4>热力图例</h4>
            <p>学校数（个）</p>
            <div class="color"></div>
            <ul v-if="regionalRanking[0] && regionalRanking[0].schoolCount > 0">
              <li>
                <div class="text">
                  <img src="@/assets/areaScreen/area-up.png" alt="" /><br />
                  1
                </div>
              </li>
              <li>
                <div class="text">
                  <img src="@/assets/areaScreen/area-up.png" alt="" /><br />
                  {{ regionalRanking[0].schoolCount }}
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { arrayDeduplication } from '@/utils/methods'

export default {
  name: 'index',
  data() {
    return {
      isFullScreen: false,
      scrollInterval: null,
      basicInfo: {},
      online: {},
      statistics: {
        evaluationData: {},
        trainingData: {},
      },
      regionalRanking: [],
    }
  },
  filters: {
    formetNumber(val) {
      if (!val) return 0
      return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
  },
  created() {
    this.getUserAndCourseStatistics()
  },
  mounted() {
    window.addEventListener('resize', this.resizeWindow)
    this.getAreaUserSummary()
    this.getCountryBoardData()
    this.getOnlineCount()
  },
  beforeDestroy() {
    window.clearInterval(this.scrollInterval)
    window.removeEventListener('resize', this.resizeWindow)
  },
  methods: {
    getAreaUserSummary() {
      this.$http.User.getAreaUserSummary().then((res) => {
        this.basicInfo = res.data
      })
    },
    getOnlineCount() {
      this.$http.User.getOnlineCount().then((res) => {
        this.online = res.data
      })
    },
    getCountryBoardData() {
      this.$http.Data.getCountryBoardData().then((res) => {
        const data = res.data
        this.regionalRanking = data
        this.$nextTick(() => {
          window.clearInterval(this.scrollInterval)
          if (this.regionalRanking.length > 14) {
            let index = 0
            const height = 34
            const list = this.$refs.tableRank.children
            const fn = () => {
              for (let i = 0; i < list.length; i++) {
                let y = height * (i - index - 1),
                  opacity = 1
                if (i - index < 0) {
                  y = height * (i - index + list.length - 1)
                }
                if (y < 0) {
                  opacity = 0
                  window.setTimeout(() => {
                    opacity = 1
                    list[i].animate(
                      {
                        transform: 'translateY(' + height * (list.length - 1) + 'px)',
                        opacity,
                      },
                      {
                        duration: 0,
                        fill: 'forwards',
                      }
                    )
                  }, 500)
                } else {
                  opacity = 1
                }
                list[i].animate(
                  {
                    transform: 'translateY(' + y + 'px)',
                    opacity,
                  },
                  {
                    duration: 500,
                    fill: 'forwards',
                  }
                )
              }
              if (index++ > list.length - 1) {
                index = 1
              }
            }
            fn()
            this.scrollInterval = window.setInterval(fn, 2000)
          } else {
            const list = this.$refs.tableRank.children
            for (let i = 0; i < list.length; i++) {
              list[i].style.position = 'relative'
            }
          }
        })
        this.loadMap()
      })
    },
    getUserAndCourseStatistics() {
      this.$http.User.getUserAndCourseStatistics().then((res) => {
        this.statistics = res.data
      })
    },
    loadMap() {
      Promise.all([this.getMapData(`${process.env.VUE_APP_TEMPLATE_URL}/map/100000_full.json`), this.getMapData(`${process.env.VUE_APP_TEMPLATE_URL}/map/100000.json`)]).then(([res1, res2]) => {
        this.$echarts.registerMap('china', { geoJSON: res1 })
        this.$echarts.registerMap('chinaBack', { geoJSON: res2 })
        const arr = JSON.parse(JSON.stringify(this.regionalRanking))
        const mapColor = arrayDeduplication(
          arr.sort((a, b) => a.schoolCount - b.schoolCount),
          'schoolCount'
        ).reduce((pre, cur, index, array) => ((pre[cur.schoolCount] = Math.round((40 / (array.length - 1)) * index + 20) / 100), pre), {})
        const option = {
          geo: [
            {
              map: 'chinaBack',
              // zoom: 0.65,
              // 位置大小调整
              layoutCenter: ['52%', '72%'], //位置
              layoutSize: '112%', //大小
              aspectScale: 0.77,
              silent: true,
              show: true,
              roam: false,
              label: {
                show: false,
              },
              itemStyle: {
                areaColor: 'rgba(130, 195, 255, 0)',
                borderColor: 'rgba(106,185,252, 1)',
                borderWidth: 2,
                shadowColor: '#00B2FF',
                shadowOffsetX: 0,
                shadowOffsetY: -3,
                shadowBlur: 30,
              },
            },
            {
              type: 'map',
              map: 'china',
              silent: true,
              // zoom: 0.65,
              // 位置大小调整
              layoutCenter: ['52%', '72%'], //位置
              layoutSize: '112%', //大小
              aspectScale: 0.77,
              show: true,
              roam: false,
              label: {
                emphasis: {
                  show: false,
                },
              },
              itemStyle: {
                normal: {
                  borderColor: 'rgba(192,243,251,0.2)',
                  borderWidth: 1,
                  areaColor: 'rgba(19,156,255,0.1)',
                },
              },
              regions: [
                {
                  name: '南海诸岛',
                  selected: false,
                  emphasis: {
                    disabled: true,
                  },
                  itemStyle: {
                    areaColor: 'rgba(130, 195, 255, 0.3)',
                    borderColor: 'rgba(106,185,252, 1)',
                    borderWidth: 1,
                    shadowColor: '#00B2FF',
                    shadowOffsetX: 0,
                    shadowOffsetY: -3,
                    shadowBlur: 30,
                  },
                },
              ],
            },
            // 重影
            {
              type: 'map',
              map: 'chinaBack',
              zlevel: -1,
              // zoom: 0.65,
              // 位置大小调整
              layoutCenter: ['52%', '73.5%'], //位置
              layoutSize: '112%', //大小
              aspectScale: 0.77,
              roam: false,
              silent: true,
              itemStyle: {
                normal: {
                  borderWidth: 1,
                  // borderColor:"rgba(17, 149, 216,0.6)",
                  borderColor: 'rgba(58,149,253,0.6)',
                  shadowColor: '#40A5FF',
                  shadowOffsetY: -15,
                  shadowBlur: 115,
                  areaColor: 'rgba(24,129,250,0.1)',
                },
              },
              // 去除南海诸岛阴影 series map里面没有此属性
              regions: [
                {
                  name: '南海诸岛',
                  selected: false,
                  emphasis: {
                    disabled: true,
                  },
                  itemStyle: {
                    opacity: 0,
                  },
                },
              ],
            },
            {
              type: 'map',
              map: 'chinaBack',
              zlevel: -2,
              // zoom: 0.65,
              // 位置大小调整
              layoutCenter: ['52%', '75%'], //位置
              layoutSize: '112%', //大小
              aspectScale: 0.77,
              roam: false,
              silent: true,
              itemStyle: {
                normal: {
                  borderWidth: 1,
                  // borderColor: "rgba(57, 132, 188,0.4)",
                  borderColor: 'rgba(0,0,0,0.5)',
                  shadowColor: 'rgba(0,0,0,1)',
                  shadowOffsetY: -15,
                  shadowBlur: 65,
                  areaColor: 'rgba(0,0,0,0.3)',
                },
              },
              regions: [
                {
                  name: '南海诸岛',
                  selected: false,
                  emphasis: {
                    disabled: true,
                  },
                  itemStyle: {
                    opacity: 0,
                  },
                },
              ],
            },
          ],
          tooltip: {
            trigger: 'item',
            position: function (arr) {
              return [arr[0] - 122, arr[1] - 172]
            },
            className: 'echarts-tooltip',
            formatter: (params) => {
              if (!params.data) {
                params.data = {}
              }
              return `<div class="echarts-tooltip-content"><h3>${params.name}</h3>
                                    <p>学校数：<span>${params.data.schoolCount || '--'}</span></p>
                                    <p>学生数：<span>${this.replaceNumber(params.data.studentCount)}</span></p>
                                    </div>`
            },
          },
          series: [
            {
              type: 'map',
              mapType: 'china',
              showLegendSymbol: true,
              selectedMode: 'multiple',
              label: {
                align: 'center',
                color: '#fff',
                fontSize: 16,
              },
              itemStyle: {
                areaColor: 'rgba(130, 195, 255, 0)',
                borderWidth: 0,
              },
              select: {
                disabled: true,
              },
              emphasis: {
                disabled: true,
                label: {
                  color: '#38FFB7',
                  align: 'center',
                  fontSize: 16,
                },
                itemStyle: {
                  areaColor: 'rgba(75,245,153,0.23)',
                  borderColor: '#4BF599',
                  borderWidth: 2,
                },
              },
              // silent: true,
              // 位置大小调整
              layoutCenter: ['52%', '72%'], //位置
              layoutSize: '112%', //大小
              aspectScale: 0.77,
              data: this.regionalRanking.map((m, i) => {
                return {
                  ...m,
                  name: m.address,
                  itemStyle: {
                    borderWidth: 1.5,
                    borderColor: 'rgba(88,225,255,0.7)',
                    areaColor: `rgba(19,156,255,${mapColor[m.schoolCount]})`,
                    shadowColor: '#00B2FF',
                    shadowOffsetX: -3,
                    shadowOffsetY: -3,
                    shadowBlur: 20,
                  },
                  label: {
                    show: true,
                  },
                  emphasis: {
                    disabled: false,
                  },
                }
              }),
            },
          ],
        }
        const myChart = this.$echarts.init(this.$refs.mapChars)
        myChart.setOption(option)
      })
    },
    resizeWindow() {
      const clientHeight = document.documentElement.clientHeight || document.body.clientHeight
      this.isFullScreen = window.screen.height === clientHeight
    },
    replaceNumber(number) {
      if (!number && number !== 0) {
        return '--'
      }
      return (number + '').replace(/(?=\B(\d{3})+$)/g, ',')
    },
    getMapData(url) {
      return new Promise((resolve) => {
        const xhr = new XMLHttpRequest()
        xhr.open('GET', url, true)
        xhr.send(null)
        xhr.onload = () => {
          resolve(JSON.parse(xhr.response))
        }
      })
    },
    listenerFullScreen() {
      const clientHeight = document.documentElement.clientHeight || document.body.clientHeight
      this.isFullScreen = window.screen.height === clientHeight
    },
    fullScreen(e) {
      if (!this.isFullScreen) {
        if (document.documentElement.RequestFullScreen) {
          document.documentElement.RequestFullScreen()
        }
        //兼容火狐
        if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen()
        }
        //兼容谷歌等可以webkitRequestFullScreen也可以webkitRequestFullscreen
        if (document.documentElement.webkitRequestFullScreen) {
          document.documentElement.webkitRequestFullScreen()
        }
        //兼容IE,只能写msRequestFullscreen
        if (document.documentElement.msRequestFullscreen) {
          document.documentElement.msRequestFullscreen()
        }
      } else {
        if (document.exitFullScreen) {
          document.exitFullscreen()
        }
        //兼容火狐
        if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        }
        //兼容谷歌等
        if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen()
        }
        //兼容IE
        if (document.msExitFullscreen) {
          document.msExitFullscreen()
        }
      }
    },
  },
}
</script>

<style lang="less" scoped>
@font-face {
  font-family: title-font;
  src: url('../../../assets/font/title-font.ttf');
}
.right-statistice-wrapper {
  display: flex;
  margin-top: 22px;
  position: absolute;
  z-index: 99999;
  margin-left: 32px;
  .right-statistice-item:first-child {
    margin-right: 16px;
  }
  .right-statistice-item {
    width: 678px;
    height: 128px;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    border-radius: 8px 8px 8px 8px;
    border: 1px solid #568ff7;
    border-bottom-color: #4074e54b;
    background: #4074e54b;
    .statistice-header {
      width: 100%;
      height: 32px;
    }
    .statistice-container {
      display: flex;
      justify-content: space-between;
      padding: 0 16px;
      margin-top: 16px;
      .statistice-container-item {
        display: flex;
        gap: 12px;
        align-items: center;
        .container-item-icon {
          width: 54px;
          height: 54px;
        }
        .container-item-data {
          display: flex;
          flex-direction: column;
          .container-item-data-number {
            color: #fff500;
            font-weight: bold;
            font-size: 24px;
          }
          .container-item-data-label {
            font-weight: 400;
            font-size: 16px;
            color: #ffffff;
          }
        }
      }
    }
  }
}

#area-screen-box {
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  overflow: auto;

  &::-webkit-scrollbar {
    width: 3px;
    height: 6px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 2px;
    -webkit-box-shadow: inset 0 0 2px rgba(36, 142, 240, 0.73);
    background: rgba(36, 142, 240, 0.73);
  }

  &::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 2px transparent;
    border-radius: 2px;
    background: transparent;
  }
}

#area-screen {
  min-width: 1920px;
  min-height: 1080px;
  width: 100%;
  height: 100%;
  background-image: url('../../../assets/areaScreen/area-back.png');
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
}

.header {
  height: 74px;
  flex-shrink: 0;
  position: relative;
  z-index: 2;
  text-align: center;
  background-image: url('../../../assets/areaScreen/cs-head-back.png');
  background-size: 100% auto;

  span {
    font-family: title-font;
    font-size: 40px;
    font-weight: 400;
    line-height: 70px;
    letter-spacing: 5px;
    text-shadow: 0 0 44px #4d5ec5;
    background: linear-gradient(to bottom, #c2e9ff 0%, #ffffff 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: rgba(255, 255, 255, 0.8);
  }

  .header-screen {
    font-size: 18px;
    color: #eff7ff;
    position: absolute;
    bottom: 0;
    right: 48px;
    cursor: pointer;

    &:before {
      content: '';
      display: inline-block;
      width: 24px;
      height: 24px;
      background-image: url('../../../assets/areaScreen/cs-icon9.png');
      background-size: cover;
      vertical-align: middle;
      margin-right: 5px;
    }
  }
}

@font-face {
  font-family: Furore-Regular;
  src: url('../../../assets/font/Furore-2.otf');
}

#screen-country {
  padding: 0 48px 40px;
  flex: 1 1;
  display: flex;
  background-size: 100%;
}

.left {
  width: 420px;
  flex-shrink: 0;
  margin-top: 24px;

  .student-number {
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;

    & > div {
      width: 196px;
      height: 55px;
      background-image: url('../../../assets/areaScreen/area-icon3.png');
      background-repeat: no-repeat;
      position: relative;
    }
    .student-info {
      position: absolute;
      right: 0;
    }
    & > div:nth-child(2) {
      background-image: url('../../../assets/areaScreen/area-icon4.png');
      width: 196px;
      height: 55px;
      background-repeat: no-repeat;
      position: relative;
      background-size: 100%;
    }

    p {
      font-size: 14px;
      color: #eff7ff;
      margin: 0;
    }

    span {
      line-height: 27px;
      margin-right: 2px;
      font-size: 24px;
      font-weight: bold;
      background: linear-gradient(180deg, #fff50a 0%, #cbf3b2 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }

  .org-info {
    padding: 0;
    margin-bottom: 24px;

    li {
      height: 58px;
      background-image: url('../../../assets/areaScreen/area-back1.png');
      margin-bottom: 8px;
      display: flex;
      align-items: center;
      padding: 0 24px;
    }

    img {
      width: 42px;
      height: 42px;
      margin-right: 16px;
    }

    p {
      width: 100px;
      font-size: 16px;
      color: #eff7ff;
      margin: 0 80px 0 0;
    }

    div {
      font-size: 14px;
      color: #eff7ff;

      span {
        font-size: 22px;
        font-weight: 500;
        margin-right: 3px;
      }
    }
  }

  .table-rank,
  .table-rank2 {
    width: 100%;
    text-align: center;
    font-size: 14px;
    color: #eff7ff;
    padding: 0;
    margin: 0;
    list-style: none;

    li {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 34px;

      &:nth-of-type(even) {
        background: rgba(58, 142, 219, 0.2);
      }

      span {
        font-size: 16px;
        font-weight: bold;
        color: #6fa3ff;
      }

      .number {
        font-size: 16px;
        color: #aae26c;
        letter-spacing: 1px;
        font-family: Furore-Regular;
      }
    }

    .table-head {
      height: 32px;
      background-image: url('../../../assets/areaScreen/area-back2.png');
    }

    .table-td {
      &:nth-of-type(1) {
        width: 75px;
      }

      &:nth-of-type(2) {
        flex: 1 1;
      }

      &:nth-of-type(3) {
        width: 85px;
      }

      &:nth-of-type(4) {
        width: 105px;
      }
    }
  }

  .table-rank2 {
    position: relative;
    height: 374px;
    overflow: hidden;

    li {
      position: absolute;
      top: 0;
      left: 0;
    }
  }
}

.title {
  height: 50px;
  background-image: url('../../../assets/areaScreen/area-title.png');
  background-size: 100% 100%;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  font-size: 22px;
  font-weight: bold;
  color: #ecf4fa;

  img {
    width: 30px;
    height: 30px;
    object-fit: cover;
    margin: 0 16px;
  }

  span {
    color: #9ada69;
    margin-right: 8px;
  }
}

.right {
  flex: 1 1;
  position: relative;
}

#map-chars {
  width: 100%;
  height: 100%;
  //   transform: translate(36px, -20px);
}

.map-legend {
  position: absolute;
  left: 40px;
  bottom: 50px;
  text-align: center;

  h4 {
    font-size: 16px;
    font-weight: 500;
    color: #c1edff;
    margin-bottom: 20px;
  }

  p {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.87);
  }

  ul {
    list-style: none;
    display: flex;
    justify-content: space-between;
    padding: 0;
  }

  .color {
    width: 192px;
    height: 12px;
    background: linear-gradient(90deg, rgba(19, 156, 255, 0.2) 0%, rgba(19, 156, 255, 0.7) 100%);
  }

  li {
    position: relative;
    text-align: center;
    color: rgba(255, 255, 255, 0.87);
    line-height: 16px;
    transform: translateX(-50%);

    &:last-child {
      transform: translateX(50%);
    }
  }
}

/deep/ .echarts-tooltip {
  background-color: transparent !important;
  border-color: transparent !important;
  box-shadow: none !important;

  .echarts-tooltip-content {
    width: 243px;
    height: 132px;
    background-image: url('../../../assets/areaScreen/area-back10.png');
    background-size: 100% 100%;
    padding-left: 20px !important;
    padding-top: 10px;

    h3 {
      text-shadow: 0px 0px 44px #4d5ec5;
      background: linear-gradient(180deg, #c2e9ff 0%, #ffffff 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      color: rgba(255, 255, 255, 0.87);
      font-family: title-font;
      margin-top: 5px;
      margin-bottom: 10px;
    }

    p {
      margin: 0 0 8px 0;
      font-size: 14px;
      color: rgba(255, 255, 255, 0.87);
      padding-left: 10px;
    }

    span {
      font-size: 16px;
      color: #38ffb7;
      margin-left: 5px;
    }
  }
}
</style>
